import React from "react";
import { CollapsePanel } from "./CollapsePanel";
import { DetailGrid, DetailGridItem } from "./DetailGrid";

export const OtherInfo = ({ otherInfo }) => {
  return (
    <>
      <CollapsePanel labelText="Other Information">
        <DetailGrid className="detail-grid-large">
          <DetailGridItem title="Date of Service" value={otherInfo?.dateOfService} />
          <DetailGridItem title="Order Id" value={otherInfo?.orderId} />
          <DetailGridItem title="ICD Codes" value={otherInfo?.icdCodes} />
          <DetailGridItem title="Collection Date" value={otherInfo?.collectionDate} />
        </DetailGrid>
      </CollapsePanel>
    </>
  );
};
